import { combineReducers } from 'redux';
import auth from './authReducers';
import register from "./registerReducers";
import storeRegister from "./storeRegisterReducers";

// to combine all reducers together
const appReducer = combineReducers({
  auth, register, storeRegister
});

export default appReducer;